import 'index.css';
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import { NavigationSetup } from 'hooks/useHookRouterCompat';

const RootComponent = () => (
  <BrowserRouter basename={process.env.PUBLIC_URL || ''}>
    <NavigationSetup>
      <StyleSheetManager>
        <App />
      </StyleSheetManager>
    </NavigationSetup>
  </BrowserRouter>
);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<RootComponent />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
